import appSettings from "appsettings.json";

const getToken = () => {
  // This is a placeholder. In a real application, you would retrieve your
  // authentication token from a secure storage mechanism like localStorage,
  // sessionStorage, or a global state management solution (e.g., Redux, Context API).
  // For demonstration, we'll assume it's stored in localStorage.
  return localStorage.getItem("token");
};

const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json", // Default content type for most APIs
    ...options.headers, // Allow overriding or adding other headers
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const newOptions = {
    ...options,
    headers,
  };

  let response;
  try {
    response = await fetch(url, newOptions);
  } catch (error) {
    // This handles cases where fetch throws (e.g., CORS errors on a 401 or network issues)
    console.error("Initial fetch failed:", error);
    throw error;
  }

  // If Unauthorized (401), attempt to refresh the token using the refreshToken
  if (response.status === 401) {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
      const refreshUrl = `${appSettings.baseUrl}${appSettings.endpoints.refreshToken}`;
      let refreshResponse;

      try {
        refreshResponse = await fetch(refreshUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refreshToken }),
        });
      } catch (e) {
        refreshResponse = { ok: false };
      }

      if (refreshResponse.ok) {
        const data = await refreshResponse.json();
        localStorage.setItem("token", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);

        // Update headers and retry the original request with the new token
        newOptions.headers.Authorization = `Bearer ${data.token}`;
        response = await fetch(url, newOptions);

        // If the retried request is also 401, log out as the new token is invalid
        if (response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          window.location.href = "/authentication/mobile-sign-in";
          return response;
        }
      } else {
        // If refresh fails for any reason (including 401), log out
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/authentication/mobile-sign-in";
        return response; // Stop execution
      }
    } else {
      // No refresh token available to recover from 401, log out
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.href = "/authentication/mobile-sign-in";
      return response; // Stop execution
    }
  }

  if (response.status === 403) {
    throw new Error("you are not authorized to proceed this action");
  }

  if (response.status === 429) {
    throw new Error("Request limit exceeded. Please try again shortly");
  }

  return response;
};

export default fetchWithAuth;
